export default "__VITE_ASSET__CypX77Ok__"